module.exports = __webpack_public_path__ + "img/story_picture.bb4319f1.jpg";